// THEMES is the overall structure of our themes and actions
export const THEMES = Object.freeze({
  dienstverlening: [
    "digitale_dienstverlening",
    "variatie_openingsuren",
    "enkel_afspraak",
    "automatiseren",
    "bib_ontmoetingsplek",
  ],
  dialoog: [
    "lokale_netwerken",
    "overleg_diensten_vereniging",
    "inwoners_betrekken",
    "evenementen_subsidies",
    "subsidiereglementen",
  ],
  buurten: [
    "buurtcomites_opstarten",
    "ondersteuningsnetwerken",
    "financiele_ondersteuning",
    "herinrichten_omeving",
    "overleg_werking",
  ],
});
